import { withInstall } from '../utils/index';
import Menu from './menu';
import './index.less';

export const TlbsMenu = withInstall(Menu);
export default TlbsMenu;
